import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowSmallRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.333 13.333 11.667 10 8.333 6.667"
    />
  </svg>
);
export default SvgArrowSmallRight;
